import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';
import { AuthGuard } from '@titan/devkit/user';
import { TitanTitleStrategy } from '@titan/devkit/core';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        loadChildren: () => import('@gaia/gaia/login/feature-login').then(m => m.LoginFeatureLoginModule),
    },
    {
        path: 'browse',
        loadChildren: () => import('@gaia/gaia/browse/feature-browse').then(browse => browse.routes),
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
    exports: [RouterModule],
    providers: [
        {
            provide: TitleStrategy,
            useClass: TitanTitleStrategy,
        },
    ],
})
export class AppRouterModule {}
